<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {}
    },
    methods: {},
}
</script>

<template>
    <b-container class="mt-3 mb-5">
        <router-view />
    </b-container>
</template>

<style lang="scss" scoped>
</style>
